module.exports = __webpack_public_path__ + "static/media/SDFSA_7-634w.1454cb66.webp";